// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.chapters-container {
  padding: 0;
  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);
  min-height: 100vh;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

/* Premium Hero Banner */
.chapters-hero-banner {
  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);
  color: white;
  padding: 40px 30px;
  margin-bottom: 0;
  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);
}

.hero-content {
  margin-bottom: 30px;
}

.hero-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.hero-content h1 {
  margin: 0 0 10px 0;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.8px;
}

.hero-content p {
  margin: 0;
  font-size: 16px;
  opacity: 0.95;
  max-width: 600px;
}

.hero-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.hero-stat {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  padding: 16px 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.hero-stat:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon.chapters-count {
  background: rgba(198, 161, 91, 0.2);
  color: #c6a15b;
}

.stat-icon.members-count {
  background: rgba(47, 111, 94, 0.2);
  color: #3d8a76;
}

.stat-icon.cities-count {
  background: rgba(28, 58, 99, 0.2);
  color: #1c3a63;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 12px;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-value {
  font-size: 28px;
  font-weight: 800;
}

/* Header */
.chapters-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 30px;
}

.header-content h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0a1628;
  letter-spacing: -0.4px;
}

.header-subtitle {
  margin: 8px 0 0 0;
  color: #48546b;
  font-size: 14px;
}

.btn-create-chapter {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(16, 31, 56, 0.25);
}

.btn-create-chapter:hover {
  background: linear-gradient(135deg, #132b4d 0%, #245349 100%);
  box-shadow: 0 12px 32px rgba(16, 31, 56, 0.35);
  transform: translateY(-2px);
}

.btn-create-chapter:active {
  transform: translateY(0);
}

/* Form Card */
.chapter-form-card {
  background: white;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  margin: 30px;
  animation: slideDown 0.3s ease;
  border: 1px solid rgba(16, 31, 56, 0.08);
}

.chapter-form-card h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 800;
  color: #0a1628;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Alerts */
.alert-success,
.alert-error {
  padding: 14px 16px;
  border-radius: 10px;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 600;
  border-left: 4px solid;
}

.alert-success {
  background: linear-gradient(135deg, #e3efe9 0%, #e3efe9 100%);
  color: #245349;
  border-left-color: #3d8a76;
}

.alert-error {
  background: linear-gradient(135deg, #fbeae5 0%, #fbeae5 100%);
  color: #8a3322;
  border-left-color: #c9563a;
}

/* Form */
.chapter-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #0a1628;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  padding: 10px 14px;
  border: 1px solid #e3ddcd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #2f6f5e;
  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.btn-submit,
.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit {
  background: #2f6f5e;
  color: white;
  flex: 1 1;
  justify-content: center;
}

.btn-submit:hover:not(:disabled) {
  background: #245349;
  transform: translateY(-1px);
}

.btn-submit:disabled {
  background: #d8cfb8;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-cancel {
  background: #f1ede2;
  color: #48546b;
  flex: 1 1;
  justify-content: center;
}

.btn-cancel:hover {
  background: #e3ddcd;
}

/* Filters */
.chapters-filters {
  background: white;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 25px;
  margin: 30px 30px 25px 30px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid #e3ddcd;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s ease;
  box-sizing: border-box;
  background: white;
}

.search-input:focus {
  outline: none;
  border-color: #101f38;
  box-shadow: 0 0 0 3px rgba(16, 31, 56, 0.08);
  background: #f1ede2;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  min-height: 300px;
  margin: 30px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.spinner {
  animation: spin 1s linear infinite;
  color: #101f38;
  margin-bottom: 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  color: #48546b;
  font-size: 14px;
}

/* Empty State */
.empty-container {
  display: flex;
  margin: 30px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-height: 300px;
}

.empty-container svg {
  color: #d8cfb8;
  margin-bottom: 15px;
}

.empty-container h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #0a1628;
}

.empty-container p {
  margin: 0;
  color: #8792a6;
  font-size: 14px;
  text-align: center;
  max-width: 300px;
}

/* Chapters Grid */
.chapters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  padding: 0 30px 30px 30px;
}

/* Chapter Card */
.chapter-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.chapter-card.premium:hover {
  box-shadow: 0 16px 40px rgba(16, 31, 56, 0.12);
  transform: translateY(-6px);
  border-color: rgba(16, 31, 56, 0.2);
}

.card-accent-bar {
  height: 4px;
  background: linear-gradient(90deg, #101f38 0%, #3d8a76 50%, #101f38 100%);
}

.card-header {       
  background: linear-gradient(
    135deg,
    rgba(16, 31, 56, 0.03) 0%,
    rgba(16, 31, 56, 0.01) 100%
  );
  color: #0a1628;
  padding: 20px;
  border-bottom: 1px solid rgba(16, 31, 56, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.3px;
  color: #0a1628;
}

.member-badge {
  display: inline-block;
  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
}

/* Card Content */
.card-content {
  padding: 20px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #48546b;
}

.info-item svg {
  flex-shrink: 0;
  color: #101f38;
  stroke-width: 2.5;
}

.info-item.icon-pin {
  color: #3d8a76;
}

.info-item.description {
  color: #48546b;
  line-height: 1.6;
  font-size: 13px;
}

.info-item span {
  word-break: break-word;
}

/* Card Footer */
.card-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
  background: rgba(16, 31, 56, 0.02);
}

.card-footer small {
  color: #8792a6;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

/* Responsive */
@media (max-width: 768px) {
  .chapters-container {
    padding: 20px;
  }

  .chapters-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .btn-create-chapter {
    width: 100%;
    justify-content: center;
  }

  .chapters-grid {
    grid-template-columns: 1fr;
  }

  .header-content h1 {
    font-size: 24px;
  }

  .chapter-form-card {
    padding: 20px;
  }
}
/* =========================
   CARD ACTION BUTTONS
========================= */
.card-actions {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
}

/* Common button style */
.btn-edit,
.btn-delete {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
}

/* =========================
   EDIT BUTTON ✏️
========================= */
.btn-edit {
  background: linear-gradient(135deg, #101f38, #132b4d);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 31, 56,0.25);
}

.btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 31, 56,0.35);
  background: linear-gradient(135deg, #132b4d, #245349);
}

/* =========================
   DELETE BUTTON 🗑️
========================= */
.btn-delete {
  background: rgba(201, 86, 58, 0.1);
  color: #b3432b;
  border: 1px solid rgba(201, 86, 58, 0.3);
}

.btn-delete:hover {
  background: #b3432b;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(179, 67, 43,0.3);
}
/* =========================
   CONFIRM DELETE CONTAINER
========================= */
.confirm-delete {
  margin-top: 10px;
  padding: 12px;
  border-radius: 12px;
  background: rgba(179, 67, 43, 0.05);
  border: 1px solid rgba(179, 67, 43, 0.2);
}

/* Text */
.confirm-delete p {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #8a3322;
}

/* Buttons row */
.confirm-actions {
  display: flex;
  gap: 10px;
}

/* =========================
   YES DELETE BUTTON 🔥
========================= */
.btn-confirm-delete {
  background: #b3432b;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn-confirm-delete:hover {
  background: #8a3322;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(179, 67, 43,0.3);
}

/* =========================
   CANCEL BUTTON
========================= */
.btn-cancel {
  background: #f1ede2;
  color: #48546b;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn-cancel:hover {
  background: #e3ddcd;
  transform: translateY(-2px);
}
/* MODAL */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-card {
  background: white;
  padding: 25px;
  border-radius: 16px;
  width: 420px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
}

.radio-group {
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-danger {
  background: #b3432b;
  color: white;
  padding: 10px 16px;
  border-radius: 8px;
}

.danger-text {
  color: #b3432b;
}
.modal-overlay {
  will-change: opacity;
  transform: translateZ(0);
}
.modal-overlay {
  background: rgba(0,0,0,0.35);
  backdrop-filter: blur(6px);
}
.modal-overlay {
  animation: fadeIn 0.25s ease-out;
}

.modal-card {
  animation: popIn 0.25s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes popIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}

.chapter-dropdown {
  margin-top: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #d8cfb8;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-danger {
  background: #b3432b;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  cursor: pointer;
}

.btn-danger:hover {
  background: #b3432b;
}`, "",{"version":3,"sources":["webpack://./src/admin/components/Chapters.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,UAAU;EACV,6DAA6D;EAC7D,iBAAiB;EACjB;;;;;cAKY;AACd;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE;;;;GAIC;EACD,cAAc;EACd,aAAa;EACb,+CAA+C;EAC/C,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;AACA;;2BAE2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;2BAE2B;AAC3B;EACE,qDAAqD;EACrD,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;;2BAE2B;AAC3B;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Main Container */\n.chapters-container {\n  padding: 0;\n  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);\n  min-height: 100vh;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n}\n\n/* Premium Hero Banner */\n.chapters-hero-banner {\n  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);\n  color: white;\n  padding: 40px 30px;\n  margin-bottom: 0;\n  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);\n}\n\n.hero-content {\n  margin-bottom: 30px;\n}\n\n.hero-badge {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  padding: 8px 16px;\n  border-radius: 50px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.hero-content h1 {\n  margin: 0 0 10px 0;\n  font-size: 36px;\n  font-weight: 800;\n  letter-spacing: -0.8px;\n}\n\n.hero-content p {\n  margin: 0;\n  font-size: 16px;\n  opacity: 0.95;\n  max-width: 600px;\n}\n\n.hero-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.hero-stat {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(10px);\n  padding: 16px 20px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  transition: all 0.3s ease;\n}\n\n.hero-stat:hover {\n  background: rgba(255, 255, 255, 0.12);\n  transform: translateY(-2px);\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.stat-icon.chapters-count {\n  background: rgba(198, 161, 91, 0.2);\n  color: #c6a15b;\n}\n\n.stat-icon.members-count {\n  background: rgba(47, 111, 94, 0.2);\n  color: #3d8a76;\n}\n\n.stat-icon.cities-count {\n  background: rgba(28, 58, 99, 0.2);\n  color: #1c3a63;\n}\n\n.stat-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-label {\n  font-size: 12px;\n  opacity: 0.85;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.stat-value {\n  font-size: 28px;\n  font-weight: 800;\n}\n\n/* Header */\n.chapters-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 30px;\n  padding: 30px;\n}\n\n.header-content h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #0a1628;\n  letter-spacing: -0.4px;\n}\n\n.header-subtitle {\n  margin: 8px 0 0 0;\n  color: #48546b;\n  font-size: 14px;\n}\n\n.btn-create-chapter {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 8px 24px rgba(16, 31, 56, 0.25);\n}\n\n.btn-create-chapter:hover {\n  background: linear-gradient(135deg, #132b4d 0%, #245349 100%);\n  box-shadow: 0 12px 32px rgba(16, 31, 56, 0.35);\n  transform: translateY(-2px);\n}\n\n.btn-create-chapter:active {\n  transform: translateY(0);\n}\n\n/* Form Card */\n.chapter-form-card {\n  background: white;\n  padding: 28px;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  margin: 30px;\n  animation: slideDown 0.3s ease;\n  border: 1px solid rgba(16, 31, 56, 0.08);\n}\n\n.chapter-form-card h3 {\n  margin: 0 0 20px 0;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0a1628;\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Alerts */\n.alert-success,\n.alert-error {\n  padding: 14px 16px;\n  border-radius: 10px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n  border-left: 4px solid;\n}\n\n.alert-success {\n  background: linear-gradient(135deg, #e3efe9 0%, #e3efe9 100%);\n  color: #245349;\n  border-left-color: #3d8a76;\n}\n\n.alert-error {\n  background: linear-gradient(135deg, #fbeae5 0%, #fbeae5 100%);\n  color: #8a3322;\n  border-left-color: #c9563a;\n}\n\n/* Form */\n.chapter-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #0a1628;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  padding: 10px 14px;\n  border: 1px solid #e3ddcd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #2f6f5e;\n  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.btn-submit,\n.btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-submit {\n  background: #2f6f5e;\n  color: white;\n  flex: 1;\n  justify-content: center;\n}\n\n.btn-submit:hover:not(:disabled) {\n  background: #245349;\n  transform: translateY(-1px);\n}\n\n.btn-submit:disabled {\n  background: #d8cfb8;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.btn-cancel {\n  background: #f1ede2;\n  color: #48546b;\n  flex: 1;\n  justify-content: center;\n}\n\n.btn-cancel:hover {\n  background: #e3ddcd;\n}\n\n/* Filters */\n.chapters-filters {\n  background: white;\n  padding: 16px 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  margin-bottom: 25px;\n  margin: 30px 30px 25px 30px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1.5px solid #e3ddcd;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n  background: white;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #101f38;\n  box-shadow: 0 0 0 3px rgba(16, 31, 56, 0.08);\n  background: #f1ede2;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  min-height: 300px;\n  margin: 30px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.spinner {\n  animation: spin 1s linear infinite;\n  color: #101f38;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-container p {\n  color: #48546b;\n  font-size: 14px;\n}\n\n/* Empty State */\n.empty-container {\n  display: flex;\n  margin: 30px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-height: 300px;\n}\n\n.empty-container svg {\n  color: #d8cfb8;\n  margin-bottom: 15px;\n}\n\n.empty-container h3 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  color: #0a1628;\n}\n\n.empty-container p {\n  margin: 0;\n  color: #8792a6;\n  font-size: 14px;\n  text-align: center;\n  max-width: 300px;\n}\n\n/* Chapters Grid */\n.chapters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n  padding: 0 30px 30px 30px;\n}\n\n/* Chapter Card */\n.chapter-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.chapter-card.premium:hover {\n  box-shadow: 0 16px 40px rgba(16, 31, 56, 0.12);\n  transform: translateY(-6px);\n  border-color: rgba(16, 31, 56, 0.2);\n}\n\n.card-accent-bar {\n  height: 4px;\n  background: linear-gradient(90deg, #101f38 0%, #3d8a76 50%, #101f38 100%);\n}\n\n.card-header {       \n  background: linear-gradient(\n    135deg,\n    rgba(16, 31, 56, 0.03) 0%,\n    rgba(16, 31, 56, 0.01) 100%\n  );\n  color: #0a1628;\n  padding: 20px;\n  border-bottom: 1px solid rgba(16, 31, 56, 0.08);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.card-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n  color: #0a1628;\n}\n\n.member-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, #101f38 0%, #132b4d 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 50px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n/* Card Content */\n.card-content {\n  padding: 20px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #48546b;\n}\n\n.info-item svg {\n  flex-shrink: 0;\n  color: #101f38;\n  stroke-width: 2.5;\n}\n\n.info-item.icon-pin {\n  color: #3d8a76;\n}\n\n.info-item.description {\n  color: #48546b;\n  line-height: 1.6;\n  font-size: 13px;\n}\n\n.info-item span {\n  word-break: break-word;\n}\n\n/* Card Footer */\n.card-footer {\n  padding: 14px 20px;\n  border-top: 1px solid rgba(0, 0, 0, 0.04);\n  background: rgba(16, 31, 56, 0.02);\n}\n\n.card-footer small {\n  color: #8792a6;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .chapters-container {\n    padding: 20px;\n  }\n\n  .chapters-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n\n  .btn-create-chapter {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .chapters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .header-content h1 {\n    font-size: 24px;\n  }\n\n  .chapter-form-card {\n    padding: 20px;\n  }\n}\n/* =========================\n   CARD ACTION BUTTONS\n========================= */\n.card-actions {\n  display: flex;\n  gap: 10px;\n  padding: 12px 16px;\n}\n\n/* Common button style */\n.btn-edit,\n.btn-delete {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n/* =========================\n   EDIT BUTTON ✏️\n========================= */\n.btn-edit {\n  background: linear-gradient(135deg, #101f38, #132b4d);\n  color: white;\n  box-shadow: 0 4px 12px rgba(16, 31, 56,0.25);\n}\n\n.btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(16, 31, 56,0.35);\n  background: linear-gradient(135deg, #132b4d, #245349);\n}\n\n/* =========================\n   DELETE BUTTON 🗑️\n========================= */\n.btn-delete {\n  background: rgba(201, 86, 58, 0.1);\n  color: #b3432b;\n  border: 1px solid rgba(201, 86, 58, 0.3);\n}\n\n.btn-delete:hover {\n  background: #b3432b;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(179, 67, 43,0.3);\n}\n/* =========================\n   CONFIRM DELETE CONTAINER\n========================= */\n.confirm-delete {\n  margin-top: 10px;\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(179, 67, 43, 0.05);\n  border: 1px solid rgba(179, 67, 43, 0.2);\n}\n\n/* Text */\n.confirm-delete p {\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #8a3322;\n}\n\n/* Buttons row */\n.confirm-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* =========================\n   YES DELETE BUTTON 🔥\n========================= */\n.btn-confirm-delete {\n  background: #b3432b;\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n.btn-confirm-delete:hover {\n  background: #8a3322;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(179, 67, 43,0.3);\n}\n\n/* =========================\n   CANCEL BUTTON\n========================= */\n.btn-cancel {\n  background: #f1ede2;\n  color: #48546b;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n.btn-cancel:hover {\n  background: #e3ddcd;\n  transform: translateY(-2px);\n}\n/* MODAL */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal-card {\n  background: white;\n  padding: 25px;\n  border-radius: 16px;\n  width: 420px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n}\n\n.radio-group {\n  margin: 15px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.btn-danger {\n  background: #b3432b;\n  color: white;\n  padding: 10px 16px;\n  border-radius: 8px;\n}\n\n.danger-text {\n  color: #b3432b;\n}\n.modal-overlay {\n  will-change: opacity;\n  transform: translateZ(0);\n}\n.modal-overlay {\n  background: rgba(0,0,0,0.35);\n  backdrop-filter: blur(6px);\n}\n.modal-overlay {\n  animation: fadeIn 0.25s ease-out;\n}\n\n.modal-card {\n  animation: popIn 0.25s ease-out;\n}\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes popIn {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.chapter-dropdown {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #d8cfb8;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.btn-danger {\n  background: #b3432b;\n  color: white;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.btn-danger:hover {\n  background: #b3432b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
